/* Local dependencies */
import { UIException } from '../../../redux/exceptions';

export class WarehouseNameRequiredException extends UIException {
  code = 'WarehouseNameRequiredException';
}
